import React from "react";
import PostStudioList from "../components/postStudio/PostStudioList";

const AIPostStudio = () => <PostStudioList
  source="AI"
  eyebrow="AI POST STUDIO"
  title="AI Post Studio"
  intro="Posts generated from your business profile, brand voice and calendar. Review, refine and schedule every one."
  createLabel="Create AI Post"
  createIcon="ti-sparkles"
  createPermission={["user.create_content.create", "user.content_calendar.create"]}
  actions={["preview", "edit", "schedule", "delete"]}
  emptyTitle="No AI posts this month"
  emptyText="Generate a single post for a date or festival, or plan a whole month with AI."
/>;

export default AIPostStudio;
